type FastApiDetailItem = { loc?: (string | number)[]; msg?: string };

export function parseFastApiValidationMessage(detail: unknown): string {
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((item: FastApiDetailItem) => item.msg || JSON.stringify(item))
      .filter(Boolean)
      .join(' ');
  }
  return 'Request could not be validated.';
}

/** The backend's `detail` for a failed request, or null when there is none.
 *  Pages show it verbatim: it is written for the user (basket conflicts,
 *  validation refusals), and a generic fallback hides the reason. */
export function getApiErrorDetail(error: unknown): string | null {
  const detail = (error as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail;
  if (detail == null) return null;
  const message = parseFastApiValidationMessage(detail);
  return message || null;
}
